/* eslint-disable import/prefer-default-export */
export const COURSE_UNIT_LIST = `
query($courseId: Int!) {
  courseUnitList(courseId: $courseId) {
    id
    name
    status
    progress
    isExperience
    isAvailable
  }
}`;

export const COURSE_MODULE_LIST = `
query($unitId: Int!) {
  courseModuleList(unitId: $unitId) {
    id
    reviewId
    name
    isFinished
    progress
    type
    isOpen
    reviewIsOpen
  }
}`;

export const WORD_UNIT_LIST = `
query($courseId: Int!) {
  wordUnitList(courseId: $courseId) {
    id
    name
    progress
    completeWordCount
    wordCount
    beforeScore
    afterScore
    isExperienceUnit
    isAvailable
  }
}`;

export const WRONG_BOOK_LIST = `
  query($page: Int!, $size: Int!, $code: String, $name: String, $type: String!) {
    wrongBookList(page: $page, size: $size, code: $code, name: $name, type: $type) {
      total
      list {
        courseId
        name
        code
        projectCode
        wrongCount
        wordList {
          word
          explain
        }
      }
    }
  }
`;

export const COURSE_INFO = `
  query($id: Int!) {
    courseInfo(id: $id) {
      introduction
      order
      unit
      progress
      videos {
        name
        url
      }
      banners {
        title
        image
        url
      }
    }
  }
`;

export const IAT_URL = `
  query {
    iatUrl
  }
`;
